let htcItems = document.querySelectorAll('[js-hover-to-click]');
let htcActiveClass = 'mosaic__programs__bloc__text--active';

if (window.innerWidth < 960 && htcItems) {
    htcItems.forEach((item) => {
        let htcToggle = item.querySelector('.full-link');
        let htcContent = item.querySelector('.mosaic__programs__bloc__text');
        let htcBtn = item.querySelector('.btn');
        let url = htcToggle.getAttribute('href');

        htcBtn.innerHTML = 'En savoir plus<a href="'+ url +'" class="full-link"></a>';
        htcToggle.remove();

        item.addEventListener('click', function (e) {
            e.preventDefault();
            if (htcContent.classList.contains(htcActiveClass)) {
                htcContent.classList.remove(htcActiveClass);
            } else {
                htcContent.classList.add(htcActiveClass);
            }
        });

        htcBtn.addEventListener('click', function () {
            if (url) {
                document.location.href=url;
            }
        });
    });
}
